<template>
    <div>
        <div class="ml-2 mr-2 mt-4">
            <div class="inline-block w-full bg-red-200 text-center px-4 py-2">
                {{ $t('component.profile.notready') }}

                <div v-if="user">
                    <p class="underline">
                        <PhoneSVG></PhoneSVG>
                        {{getPhoneNumber}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';
    import PhoneSVG from "@/components/shared/svgs/PhoneSVG";

    export default {
        name: "Profile",
        components: {PhoneSVG},
        computed: {
            ...mapState('auth', {
                'user': 'user'
            }),
            ...mapGetters('dlGroupConfig', [
                'getPhoneNumber',
            ]),
        }
    }
</script>

<style scoped>

</style>